/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export { HttpTestingController } from './src/api';
export { HttpClientTestingModule } from './src/module';
export { TestRequest } from './src/request';
//# sourceMappingURL=public_api.js.map